export const isAdvancedA11yEnabled = (state: AnyFixMe) =>
  state.a11y.isAdvancedA11yEnabled;
